import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-payment-link',
  templateUrl: './create-payment-link.component.html',
  styleUrls: ['./create-payment-link.component.css']
})
export class CreatePaymentLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
